module.exports = __webpack_public_path__ + "static/media/Sidebar-cashback-icon-inactive.87f62615.svg";